import http from "../../services/http";

const addFormacao = async (formulario) => {
  return await http("post", `v1/formacoes/cadastrar`, formulario);
};

const getFormacoes = async () => {
  return await http("get", `v1/formacoes/listar`, []);
};

const deleteFormacao = async (id) => {
  return await http("post", `v1/formacoes/deletar`, { id: id });
};

export { addFormacao, getFormacoes, deleteFormacao };
